import { render, staticRenderFns } from "./menzies-smart.html?vue&type=template&id=2c4f223c&"
import script from "./menzies-smart.js?vue&type=script&lang=js&"
export * from "./menzies-smart.js?vue&type=script&lang=js&"
import style0 from "./menzies-smart.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports